import {defineRule} from "vee-validate";
import {min} from '@vee-validate/rules';
import {i18n} from "@/i18n";

defineRule('min', (value, params, { field }) => {
    return min(value, params) || i18n.global.t('Validation.Min', {attribute: field, min: params[0]});
});
